import { createAsyncThunk } from '@reduxjs/toolkit';
import Api, { FetchParams } from '../utils/Api';
import { fetchMember } from './fetchMember';
import { IDeliveryDropOffCoordinatesHttpDto } from '../dtos/interfaces';

export interface ISaveAddressDto {
  deliveryAddress: DeliveryAddress;
  readonly deliveryDropOffCoordinates?: IDeliveryDropOffCoordinatesHttpDto;
}

export const saveAddress = createAsyncThunk(
  '$saveAddress',
  async (data: ISaveAddressDto, { dispatch, rejectWithValue }) => {
    // Polygon-Central has validation for address component fields that are
    // currently incompatible some non-Australian addresses. For example,
    // the UK doesn't have States and the API validation specifically checks
    // for a valid Australian state. For now, I have removed address component
    // fields, however the API does support a payload with these properties.
    const payload: DeliveryAddressPayload = {
      SDFormattedAddress: data.deliveryAddress.formattedAddress,
      SDGooglePlaceID: data.deliveryAddress.placeId,
      SDAddress1: data.deliveryAddress.displayAddress.firstLine,
      SDAddress2: data.deliveryAddress.displayAddress.secondLine,
      SDAddressID: data.deliveryAddress.addressId,
      SDAlias: data.deliveryAddress.locationName,
      SDLatitude: data.deliveryAddress.location?.latitude,
      SDLongitude: data.deliveryAddress.location?.longitude,
      SDDeliveryDropOffLatitude: data.deliveryDropOffCoordinates?.latitude,
      SDDeliveryDropOffLongitude: data.deliveryDropOffCoordinates?.longitude,
      SDAddressType: data.deliveryAddress.addressType,
      SDBuildingInformation: data.deliveryAddress.buildingInformation,
      SDDeliveryInstructions: data.deliveryAddress.deliveryInstruction,
      SDDeliveryNotes: data.deliveryAddress.deliveryNotes,
      SDCountry: data.deliveryAddress.addressComponents?.country,
      SDSuburb: data.deliveryAddress.addressComponents?.suburb,
      SDPostcode: data.deliveryAddress.addressComponents?.postCode,
    };
    try {
      const params: FetchParams = {
        path: `/api/v1/profile`,
        method: 'PUT',
        body: payload,
      };
      await Api.fetch(params, 'member');
      await dispatch(fetchMember({ authenticationMethod: 'member' }));
    } catch (e) {
      console.error('Save address thunk failed');
      return rejectWithValue(e);
    }
  },
);

export const deleteSavedAddress = createAsyncThunk(
  '$deleteSavedAddress',
  async (
    data: {
      id: number;
    },
    { dispatch, rejectWithValue },
  ) => {
    const { id } = data;

    try {
      const params: FetchParams = {
        path: `/api/v1/profile/remove_sd_address/${id}`,
        method: 'DELETE',
      };
      await Api.fetch(params, 'member');
      await dispatch(fetchMember({ authenticationMethod: 'member' }));
    } catch (e) {
      console.error('Delete save address thunk failed');
      return rejectWithValue(e);
    }
  },
);
